import React from 'react';
import { Menu } from 'lucide-react';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { APP_CONFIG } from '../../constants/appConfig';

const MobileMenuToggle = ({ onClick, isSidebarOpen }) => {
  const { user } = useContext(AuthContext);

  const getRoleColor = (role) => {
    switch(role) {
      case 'ADMIN': return 'bg-red-50 text-red-700 ring-red-200';
      case 'SERVICE_ENGINEER': return 'bg-purple-50 text-purple-700 ring-purple-200';
      default: return 'bg-blue-50 text-blue-700 ring-blue-200';
    }
  };

  const getRoleDisplay = (role) => {
    return role?.replace(/_/g, ' ') || 'User';
  };

  return (
    <nav className="fixed top-0 left-0 right-0 md:hidden z-40 bg-gradient-to-r from-slate-900 via-slate-900 to-slate-950 border-b border-slate-700 shadow-lg">
      <div className="px-6 py-4 flex items-center justify-between gap-4">
        {/* Left - Menu Toggle & Branding */}
        <div className="flex items-center gap-4">
          <button
            onClick={onClick}
            className="p-1 hover:bg-slate-800 active:bg-slate-700 rounded-lg transition duration-200 transform active:scale-95 flex-shrink-0"
            title="Toggle menu"
            aria-label="Toggle navigation menu"
          >
            <Menu className="w-6 h-6 text-slate-100" />
          </button>
          <div className="flex flex-col gap-1">
            <h1 className="text-lg font-bold text-white tracking-wide">{APP_CONFIG.appName}</h1>
            <p className="text-xs text-slate-400 leading-tight">Vehicle Management</p>
          </div>
        </div>

        {/* Right - User Info & Role */}
        <div className="flex flex-col items-end gap-1">
          <p className="text-sm font-semibold text-slate-100 leading-tight">{user?.fullName}</p>
          <span className={`text-xs font-medium px-3 py-1.5 rounded-full ring-1 ${getRoleColor(user?.role)}`}>
            {getRoleDisplay(user?.role)}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default MobileMenuToggle;
